import { desktopMediaQueryString, mobileMediaQueryString } from './breakpoints'

/**
 * https://github.com/tailwindlabs/tailwindcss-line-clamp
 *
 * .line-clamp produces better results than .line-clamp-1, but doesn't play well
 *  with flexbox. See https://css-tricks.com/flexbox-truncated-text/.
 */
const lineClamp = `
.line-clamp {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.line-clamp-1 {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
}

.line-clamp-2 {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
}

.line-clamp-3 {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
}
`

/**
 * Breaks long words and adds hyphens
 *
 * @see https://blog.logrocket.com/guide-css-word-wrap-overflow-wrap-word-break/
 * @see https://justmarkup.com/articles/2015-07-31-dealing-with-long-words-in-css/
 * @borrows app-new/src/InterNations/Bundle/LayoutBundle/Resources/public/frontend/less/responsive/base/mixins.less:200
 */
const hyphenate = `
.break-word-with-hyphens {
    overflow-wrap: break-word;
    -webkit-hyphens: auto;
    hyphens: auto;
}

.break-word {
    word-break: break-word;
}
`

const iOSFixes = `
.fixIOSScrollFlashingStart {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    -webkit-perspective: 1000;
    perspective: 1000;
}

.fixIOSScrollFlashingStart > :first-of-type {
    position: fixed;
    top: 0;
}

.fixIOSScrollFlashingEnd {
    -webkit-transform: none;
    transform: none;
}
`

const responsive = `
@media only screen and ${desktopMediaQueryString} {
    .mobile-only {
        display: none !important;
    }
}

@media only screen and ${mobileMediaQueryString} {
    .desktop-only {
        display: none !important;
    }
}

.is-container-app .hide-for-container-app {
    display: none !important;
}

.is-ios-container-app .hide-for-ios-container-app {
    display: none !important;
}

.is-android-container-app .hide-for-android-container-app {
    display: none !important;
}
`

export default `
.cursor-pointer {
    cursor: pointer;
}

.hover-no-underline:hover {
    text-decoration: none;
}

.text-wrap-nowrap {
    text-wrap: nowrap;
}

.flat-breaks br, .flat-breaks br:after {
  content: "";
}

${lineClamp}
${hyphenate}
${iOSFixes}
${responsive}
`
